const features = [
  {
    icon: "ri-search-eye-line",
    title: "深度挖掘",
    desc: "多信源交叉验证，每条猛料都经过至少三方核实，拒绝断章取义和标题党。",
  },
  {
    icon: "ri-shield-flash-line",
    title: "匿名保护",
    desc: "端到端加密投稿系统，爆料人身份信息永不泄露，让你安心说出真相。",
  },
  {
    icon: "ri-timer-flash-line",
    title: "实时追踪",
    desc: "24 小时热点监测，争议事件第一时间跟进，不错过任何一个塌房现场。",
  },
  {
    icon: "ri-file-search-line",
    title: "证据归档",
    desc: "每条爆料附带完整证据链存档，截图、录音、文件一应俱全，经得起推敲。",
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-20 md:py-28 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-100 text-center mb-4">
          为什么选择我们
        </h2>
        <div className="w-16 h-1 bg-accent-500 mx-auto mb-10 rounded-full"></div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((f, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-lg p-6 border border-background-200/50 text-center group hover:border-primary-500/30 transition-colors"
            >
              <div className="w-14 h-14 flex items-center justify-center mx-auto mb-4 rounded-full bg-primary-500/10 group-hover:bg-primary-500/20 transition-colors">
                <i className={`${f.icon} text-2xl text-primary-400`}></i>
              </div>
              <h3 className="font-heading text-foreground-200 text-base mb-2">{f.title}</h3>
              <p className="text-foreground-500 text-xs leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}